import { z } from 'zod';
export const streetAddressSchema = z.string().meta({ autocomplete: 'street-address' });
